import { render, staticRenderFns } from "./ServiceConfirmation.vue?vue&type=template&id=b5dc9a10&scoped=true&"
import script from "./ServiceConfirmation.vue?vue&type=script&lang=js&"
export * from "./ServiceConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ServiceConfirmation.vue?vue&type=style&index=0&id=b5dc9a10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dc9a10",
  null
  
)

export default component.exports